// extracted by mini-css-extract-plugin
export default {"card":"MealCard_card__57sz2","textcard":"MealCard_textcard__vIVZP","image":"MealCard_image__XwHYR","label":"MealCard_label__Q-rIe"};